import React from 'react';

import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import LoyaltyCoinIcon from './LoyaltyCoinIcon';

/** Tiers low → high; rendered left → right with the leftmost coin on top. */
const TIER_ORDER: ReadonlyArray<App.LuxLoyaltyTier> = ['bronze', 'silver', 'gold', 'platinum', 'infinite'];

interface Props {
  /** Diameter of each coin in pixels. Defaults to 24. */
  size?: number;
  /** Horizontal overlap between adjacent coins, as a fraction of `size`. Defaults to 0.35. */
  overlap?: number;
  className?: string;
  sx?: SxProps<Theme>;
}

/**
 * A row of the five loyalty tier coins (bronze → infinite) overlapping each
 * other, like a stacked avatar group. The leftmost (lowest) tier sits on top.
 */
function LoyaltyTierCoinStack({ size = 24, overlap = 0.35, className, sx }: Props) {
  const overlapPx = Math.round(size * overlap);
  return (
    <Box
      className={className}
      sx={[{ display: 'inline-flex', alignItems: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {TIER_ORDER.map((tier, index) => (
        <Box
          key={tier}
          sx={{
            display: 'inline-flex',
            marginLeft: index === 0 ? 0 : `-${overlapPx}px`,
            // Leftmost (lowest) tier sits on top, each subsequent coin tucks behind.
            zIndex: TIER_ORDER.length - index,
          }}
        >
          <LoyaltyCoinIcon tier={tier} size={size} />
        </Box>
      ))}
    </Box>
  );
}

export default LoyaltyTierCoinStack;
